// min to milliseconds
const timeConversionMinToMilli = (time: number) => {
    return time * 86400 * 1000;
}
// default cache expiry time 7 days
const defaultCacheExpiryTime= 7

export const CacheConfig = {
    PLOT_TAGS: {
        cacheTime: timeConversionMinToMilli(1),
        cacheKey: 'plotTags'
    }, 
    NEW_SOIL_TYPES: {
        cacheTime: timeConversionMinToMilli(defaultCacheExpiryTime),
        cacheKey: 'newSoilTypes'
    },
    ORGANISATIONS: {
        cacheTime: timeConversionMinToMilli(defaultCacheExpiryTime),
        cacheKey: 'organisations'
    },
    PLOT_TYPES: {
        cacheTime: timeConversionMinToMilli(defaultCacheExpiryTime),
        cacheKey: 'plotTypes'
    },
    CROPS: {
        cacheTime: timeConversionMinToMilli(defaultCacheExpiryTime),
        cacheKey: 'crops'
    },
    DEVICETYPES: {
        cacheTime: timeConversionMinToMilli(defaultCacheExpiryTime),
        cacheKey: 'deviceTypes'
    }
}

export function getDynamicCacheConfig(keyName: string, dynamicKey: string | number, dynamicTime?: number) {
    return {
        cacheKey: `${keyName}_${dynamicKey}`,
        cacheTime: timeConversionMinToMilli(dynamicTime || defaultCacheExpiryTime)
    };
}

